/* Promo landing page: copy code, countdown, tabs. No text lives here; labels come from data attributes. */
(function () {
  if (window.promoInit) return;
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true" focusable="false"><path d="M5 12l5 5L20 7"/></svg>';

  function copyBtn(b) {
    if (b.dataset.promoBound) return;
    b.dataset.promoBound = '1';
    b.addEventListener('click', function () {
      var c = b.getAttribute('data-code') || '';
      function done() {
        if (!b.dataset.label) b.dataset.label = b.innerHTML;
        b.innerHTML = CHECK + (b.getAttribute('data-copied') || '');
        b.classList.add('is-copied');
        var m = document.getElementById('promo-cpmsg');
        if (m) m.textContent = b.getAttribute('data-announce') || '';
        clearTimeout(b._t);
        b._t = setTimeout(function () {
          b.innerHTML = b.dataset.label;
          b.classList.remove('is-copied');
          if (m) m.textContent = '';
        }, 2000);
      }
      function fallback() {
        var t = document.createElement('textarea');
        t.value = c;
        t.setAttribute('readonly', '');
        t.style.position = 'fixed';
        t.style.top = '-1000px';
        t.style.opacity = '0';
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(t);
        done();
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(c).then(done, fallback);
      } else {
        fallback();
      }
    });
  }

  function countdown(el) {
    if (el._iv) clearInterval(el._iv);
    var end = Date.parse(el.getAttribute('data-end'));
    if (isNaN(end)) { el.classList.add('over'); return; }
    var u = {};
    el.querySelectorAll('[data-u]').forEach(function (x) { u[x.getAttribute('data-u')] = x; });
    function p(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (s <= 0) {
        el.classList.add('over');
        var e = el.parentNode.querySelector('.ends');
        if (e) e.textContent = el.getAttribute('data-ended');
        clearInterval(el._iv);
        return;
      }
      if (u.d) u.d.textContent = p(Math.floor(s / 86400));
      if (u.h) u.h.textContent = p(Math.floor((s % 86400) / 3600));
      if (u.m) u.m.textContent = p(Math.floor((s % 3600) / 60));
      if (u.s) u.s.textContent = p(s % 60);
    }
    el._iv = setInterval(tick, 1000);
    tick();
  }

  function tabs(l) {
    var t = [].slice.call(l.querySelectorAll('[role=tab]'));
    function sel(n, focus) {
      t.forEach(function (x, i) {
        var on = i === n;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var pnl = document.getElementById(x.getAttribute('aria-controls'));
        if (pnl) pnl.hidden = !on;
      });
      if (focus) t[n].focus();
    }
    l._promoSel = function (id) {
      t.forEach(function (x, i) { if (x.getAttribute('data-block') === id) sel(i, false); });
    };
    if (l.dataset.promoBound) return;
    l.dataset.promoBound = '1';
    t.forEach(function (x, i) {
      x.addEventListener('click', function () { sel(i, false); });
      x.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight') n = (i + 1) % t.length;
        else if (k === 'ArrowLeft') n = (i - 1 + t.length) % t.length;
        else if (k === 'Home') n = 0;
        else if (k === 'End') n = t.length - 1;
        if (n !== null) { e.preventDefault(); sel(n, true); }
      });
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('.promo-page .promo-copy').forEach(copyBtn);
    root.querySelectorAll('.promo-page .cd[data-end]').forEach(countdown);
    root.querySelectorAll('.promo-page [role=tablist]').forEach(tabs);
  }
  window.promoInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest && e.target.closest('[role=tab]');
    if (!tab) return;
    var l = tab.closest('[role=tablist]');
    if (l && l._promoSel) l._promoSel(tab.getAttribute('data-block'));
  });
})();
